import { DISPATCH_PRE_SIGNIN_STATE_SUCCESS, PRE_SIGN_IN_SUCCESS, SIGN_IN_SUCCESS } from "../constants/actionType";

export const persistData = (state = {}, action) => {
    switch (action.type) {
        case PRE_SIGN_IN_SUCCESS:
            const {
                preSignInData
            } = action;
            return {
                ...state,
                preSignInData,
            };

        case DISPATCH_PRE_SIGNIN_STATE_SUCCESS:
            const { preSignInState } = action;
            return {
                ...state,
                preSignInState,
            };

        case SIGN_IN_SUCCESS:
            const {
                signInData
            } = action;
            return {
                ...state,
                signInData,
            };

        default:
            return state;
    }
}
